export default __webpack_public_path__ + "static/media/line-chart-icon.140141df.svg";